/**
 * DataBest — Organization API client (companies, providers, group homes, houses)
 * + Users admin API.
 */
import api from "@/lib/axios";

const buildCRUD = (base) => ({
    list: (params) => api.get(base, { params }).then((r) => r.data),
    get: (id) => api.get(`${base}/${id}`).then((r) => r.data),
    create: (data) => api.post(base, data).then((r) => r.data),
    update: (id, data) => api.patch(`${base}/${id}`, data).then((r) => r.data),
    remove: (id) => api.delete(`${base}/${id}`).then((r) => r.data),
});

export const companiesApi = buildCRUD("/companies");
export const providersApi = buildCRUD("/providers");
export const groupHomesApi = buildCRUD("/group-homes");
export const housesApi = buildCRUD("/houses");
export const usersApi = buildCRUD("/users");
